import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-subscription-renewal',
  templateUrl: './subscription-renewal.component.html',
  styleUrls: ['./subscription-renewal.component.css']
})
export class SubscriptionRenewalComponent implements OnInit {
  graceEndsUtc: string | null = null;
  daysRemaining: number | null = null;

  constructor(private readonly router: Router) { }

  ngOnInit(): void {
    // Stashed by Login.ts right before navigating here (TokenResponse.User.graceEndsUtc isn't
    // otherwise persisted anywhere — currentUser only carries the merged onboarding/branding shape).
    this.graceEndsUtc = localStorage.getItem('GraceEndsUtc');
    if (this.graceEndsUtc) {
      const msRemaining = new Date(this.graceEndsUtc).getTime() - Date.now();
      this.daysRemaining = Math.max(0, Math.ceil(msRemaining / (1000 * 60 * 60 * 24)));
    }
  }

  continueToDashboard(): void {
    this.router.navigateByUrl('/dashboard');
  }

  goToRenewal(): void {
    // Admin/SubscriptionAdmin already implements plan selection + renew/cancel (Task #1/#5); a
    // non-admin invited employee without that route's permission simply sees it redirect/deny per
    // the existing AuthGuard, which is the correct outcome — only a tenant admin can actually renew.
    this.router.navigateByUrl('/admin/subscription-admin');
  }
}
